import type { RouteRecord } from "vite-react-ssg";
import Layout from "./Layout";
import Index from "./pages/Index";

const lazyDefault = (loader: () => Promise<{ default: React.ComponentType<unknown> }>) =>
  async () => {
    const mod = await loader();
    return { Component: mod.default };
  };

export const routes: RouteRecord[] = [
  {
    path: "/",
    Component: Layout,
    children: [
      { index: true, Component: Index, entry: "src/pages/Index.tsx" },
      { path: "karriere", lazy: lazyDefault(() => import("./pages/KarrierePage")) },
      { path: "bewerben", lazy: lazyDefault(() => import("./pages/BewerbenPage")) },
      { path: "impressum", lazy: lazyDefault(() => import("./pages/ImpressumPage")) },
      { path: "datenschutz", lazy: lazyDefault(() => import("./pages/DatenschutzPage")) },
      { path: "*", lazy: lazyDefault(() => import("./pages/NotFound")) },
    ],
  },
];

export default routes;
